module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/preview/demo7-75d432a60e95e6827333584d8c048b79.jpg";